import ToolbarContainer from './ToolbarContainer'
import NewEditorToolbar from './NewToolbarContainer'

export const Toolbar = ToolbarContainer
export const EditorToolbar = NewEditorToolbar
